module.exports = __webpack_public_path__ + "static/media/OilChangeEV.ec2aa281.svg";